import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useIntegration } from '~/hooks/useIntegration';

export const SlackOAuthCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { handleCallback, error } = useIntegration('slack');
  const [processing, setProcessing] = useState(true);

  useEffect(() => {
    const code = searchParams.get('code');

    if (!code) {
      setProcessing(false);
      return;
    }

    handleCallback(code)
      .then(() => {
        navigate('/integrations', { replace: true });
      })
      .catch(() => {
        setProcessing(false);
      });
  }, [searchParams, handleCallback, navigate]);

  if (error) {
    return (
      <div className="p-6 flex flex-col items-center justify-center h-64 gap-4">
        <p className="text-red-600">Failed to connect Slack: {error}</p>
        <button onClick={() => navigate('/integrations', { replace: true })} className="text-sm text-primary underline">
          Back to Integrations
        </button>
      </div>
    );
  }

  if (!searchParams.get('code')) {
    return (
      <div className="p-6 flex flex-col items-center justify-center h-64 gap-4">
        <p className="text-muted-foreground">No authorization code received.</p>
        <button onClick={() => navigate('/integrations', { replace: true })} className="text-sm text-primary underline">
          Back to Integrations
        </button>
      </div>
    );
  }

  if (processing) {
    return (
      <div className="p-6 flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary" />
      </div>
    );
  }

  return null;
};
